document.addEventListener('click',function(e){var b=e.target.closest('[data-menu]'); if(b){document.querySelector('.sn-nav')?.classList.toggle('open')}});

document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('.sn-menu');
  var menu = document.getElementById('sn-mobile-menu');
  if (button && menu) {
    button.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      menu.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(function(link){link.addEventListener('click',function(){menu.classList.remove('is-open');menu.hidden=true;button.setAttribute('aria-expanded','false');});});
  }
});
